import React from 'react';
import Container from '../../../../Common/Container/Container';
import * as classes from './PreFooter.module.scss';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../interfaces/RootState';
import NavCard from '../NavCard/NavCard';
import cn from 'classnames';
import RoundedSquare from '../RoundedSquare/RoundedSquare';
import ModernButton from '../ModernButton/ModernButton';

const PreFooter = () => {
  const { t } = useTranslation();
  const { preFooterPagesModernTemplate } = useSelector((state: RootState) => state.nav);

  return (
    <section className={classes.wrapper} data-aos='fade-in'>
      <Container>
        <div className={'row'}>
          <div className={'col-lg-4'}>
            <div className={classes.infoWrapper}>
              <div className={classes.title}>{t('preFooter.title')}</div>
              <div className={classes.subtitle}>{t('preFooter.subtitle')}</div>
              <div className={classes.buttonWrapper}>
                <ModernButton link={{ path: t('preFooter.getInTouchButton.url'), title: t('preFooter.getInTouchButton.title') }}>
                  {t('preFooter.getInTouchButton.label')}
                </ModernButton>
              </div>
            </div>
          </div>
          <div className={'col-lg-8 col-xl-7 offset-xl-1'}>
            <div className={'row'}>
              <div className={'col-sm-12 col-md-6'}>
                <NavCard {...preFooterPagesModernTemplate.items[0]} />
                <div className={'d-md-none'}>
                  <NavCard {...preFooterPagesModernTemplate.items[1]} />
                </div>
                <NavCard {...preFooterPagesModernTemplate.items[2]} />
              </div>
              <div className={cn('col-sm-12 col-md-6', classes.additionalInfoWrapper)}>
                <NavCard {...preFooterPagesModernTemplate.items[1]} />
              </div>
            </div>
          </div>
        </div>
      </Container>
      <div className={classes.decoratorWrapper}>
        <RoundedSquare />
      </div>
    </section>
  );
};

export default PreFooter;
